import {changeEvent, clickEvent, customEvent, documentLoadEvent} from "../../../webpack/modules/events";
import {
    addToCart, addToCartMultiSize, hideLoaderAddToCartButton,
    initAdvantagesCarousel,
    initImageSliders,
    initRecommenders, showLoaderAddToCartButton
} from "../../../webpack/modules-optimized/product-page";
import {addLastViewedProduct} from "../../../webpack/modules-optimized/last-viewed-products";
import {getOptions, isMultiSizeProduct, trackProductPageGa4Events} from "../../../webpack/modules-optimized/product";
import {onVisible} from "../../../scripts/Tools/visible-element-observer";
import {toggleDescriptionVisibility, updateVisibilityDescription} from "../../../webpack/modules/description";
import {removeWishListItem, saveWishListItem, toggleWishlistItem} from "../../../webpack/modules-optimized/wishlist";
import {hideModal, openModalFromHtml, showModal} from "../../../webpack/modules-optimized/modal";
import {ga4TrackSimpleEvent} from "../../../webpack/modules/analytics";
import {hideOffcanvasByDomObject, showOffcanvas} from "../../../webpack/modules-optimized/offcanvas";
import {addItem, openCart, updateItemsNumber} from "../../../webpack/modules-optimized/cart";

documentLoadEvent(function() {
    let richCard = document.querySelector('script[type="application/ld+json"]');
    let productType = '-';

    if (richCard) {
        let jsonld = JSON.parse(richCard.innerText);
        productType = (jsonld ? jsonld.category || '' : '').toLowerCase();
    }

    initImageSliders(document.querySelectorAll('main.product .image .splide'), productType);
    initAdvantagesCarousel(document.querySelectorAll('main.product .product-advantages'));
    initRecommenders(document.querySelectorAll('main.product .recommender'), productType);
    addLastViewedProduct(document.querySelector('#reference').value);
    onVisible(document.querySelectorAll(".offcanvas img"), function (image) {if (image.dataset.src) image.src = image.dataset.src;});
});

clickEvent('#product-page .open-popup-premium', false, function(element) {
    showModal('modal-user-premium');
});

clickEvent('#modal-user-premium .add-premium-to-cart', true, async function(element) {
    await addItem({'productId': element.dataset.id, 'quantity': 1, 'isLocked': true});
    hideModal('modal-user-premium');

    openCart();
    updateItemsNumber(true);
});

customEvent('show.bs.offcanvas', '#product-page .options:not(.options-section)', false, function(element) {
    trackProductPageGa4Events('OpenProductOffCanvas', 'selector_' + (element.dataset.type || '').toLowerCase());
});

customEvent('show.bs.offcanvas', '#product-page #reviews', false, function() {
    trackProductPageGa4Events('OpenProductOffCanvas', 'reviews');
});

customEvent('shown.bs.collapse', '#product-page #offcanvas-product-information .collapse', false, function(element) {
    trackProductPageGa4Events('ProductInformation', 'info_' + (item.dataset.type || '').toLowerCase());
});

clickEvent('#product-page .toggle-product-description .toggle-button', false, function (element) {
    let description = element.closest('.toggle-product-description').querySelector('.description');
    let icon = element.querySelector('i');
    if (description.classList.contains('description-closed')) {
        description.classList.remove('description-closed');
        icon.classList.remove('fa-plus');
        icon.classList.add('fa-minus');
        setTimeout(() => {description.style.maxHeight = description.scrollHeight+'px'}, 500);
    } else {
        description.classList.add('description-closed');
        icon.classList.remove('fa-minus');
        icon.classList.add('fa-plus');
        description.style.maxHeight = '';
    }
});

clickEvent('#product-page .open-product-information', false, function(element) {

    let buttonDescription = element.querySelector('.button-description');
    let description = document.querySelector('#product-page #offcanvas-product-information .description');

    if (description.textContent.trim() === '') {
        description.innerHTML = buttonDescription.innerHTML;
        updateVisibilityDescription([description]);
        setTimeout(() => {showOffcanvas('offcanvas-product-information')}, 200);
    } else {
        showOffcanvas('offcanvas-product-information');
    }
});

changeEvent('#product-page .product-complements', false, function(element) {
    let name = element.dataset.name || '-';
    let type = element.dataset.type || '-';

    if (element.checked) {
        if (type === 'sample_image') trackProductPageGa4Events('SampleImage', name);
        else trackProductPageGa4Events('Complement', name);
    }
});

changeEvent('#product-page .product-cross-selling', false, function(element) {
    let name = element.dataset.name || '-';

    if (element.checked) trackProductPageGa4Events('CrossSelling', name);
});

clickEvent('#product-page .btn-add-to-cart', false, function(element) {
    let container = element.closest('.product-scope');

    if (isMultiSizeProduct(container)) addToCartMultiSize(container);
    else addToCart(container);
});

clickEvent('#product-page .description-container .change-description-visibility', false, function(button) {
    toggleDescriptionVisibility(button.closest('.description-container'));
});

clickEvent('#product-page .add-item-wish-list', false, async function(element, e) {
    e.stopPropagation();
    element.classList.add('blinker-fast');
    let productId = element.dataset.productId;
    let response = await toggleWishlistItem(productId);
    element.classList.remove('blinker-fast');
    let error = !response.done;
    let popup = response.popup;
    let added = response.action === 'added';

    if (error) {
        if (popup) openModalFromHtml(popup);
        window.facebookSignWithInit();
        google.accounts.id.renderButton(
            document.querySelector('#login-dialog').querySelector('.g_id_signin'),
            { type: "icon", size: "large", theme: "outline" }
        );
        return;
    }

    if (added) saveWishListItem(productId);
    else removeWishListItem(productId);
    updateWishListButton(element, added);

    ga4TrackSimpleEvent({
        event: 'product',
        method: added ? 'add_to_wishlist' : 'remove_from_wishlist'
    });
});

clickEvent('#product-page .btn-add-to-cart-sample-product', false, async function(button) {
    let offcanvas = button.closest('.offcanvas');
    let productAssociatedOptions = getOptions(document.querySelector('#product-page'));

    showLoaderAddToCartButton(button);

    let data = {};
    data['productId'] = button.dataset.productId;
    data['quantity'] = 1;
    data['isLocked'] = true;
    data['options'] = {};
    data['options']['width'] = button.dataset.width;
    data['options']['height'] = button.dataset.height;
    data['options']['device'] = button.dataset.device;
    data['options']['composition'] = button.dataset.composition;
    data['options']['associatedProduct'] = button.dataset.associatedProduct;
    if (productAssociatedOptions['color']) data['options']['color'] = productAssociatedOptions['color'];

    await addItem(data);
    if (offcanvas) hideOffcanvasByDomObject(offcanvas);
    openCart();
    updateItemsNumber(true);
    hideLoaderAddToCartButton(button);
    ga4TrackSimpleEvent({event: 'sample_product', method: 'add_to_cart'});
});

function updateWishListButton(button, added)
{
    let icon = button.querySelector('i');
    if (added) {
        button.classList.add('added');
        icon.classList.remove('far');
        icon.classList.add('fas');
    } else {
        button.classList.remove('added');
        icon.classList.remove('fas');
        icon.classList.add('far');
    }
}